import { MachineListDto } from "../../../../core/models/machines/machine-list-dto";

export const baseColumnValues =
{
  visible: false,
  required: false
}

export const biometriaColumns = [
  {
    ...baseColumnValues,
    columnDef: 'biometriaInfo.biometriaGpxId',
    header: 'SDC ID',
    cell: (element: MachineListDto) => `${element.biometriaInfo.biometriaGpxId}`,
  },
  {
    columnDef: 'biometriaInfo.biometriaCompanyId',
    header: 'SDC Namn',
    cell: (element: MachineListDto) => `${element.biometriaInfo.biometriaCompanyId}`,
    ...baseColumnValues
  },
  {
    columnDef: 'biometriaInfo.biometriaPassword',
    header: 'SDC lösenord',
    cell: (element: MachineListDto) => `${element.biometriaInfo.biometriaPassword}`,
    ...baseColumnValues
  },
]

export const equipmentColumns = [
  {
    columnDef: 'equipmentInfo.hasHighPrecisionCraneTipCoordinate',
    header: 'Kranspetskoordinat, högprecision',
    cell: (element: MachineListDto) => `${`${element.equipmentInfo.hasHighPrecisionCraneTipCoordinateText}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.hasRtk',
    header: 'RTK',
    cell: (element: MachineListDto) => `${`${element.equipmentInfo.hasRtkText}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.machineComputerText',
    header: 'Maskindator',
    cell: (element: MachineListDto) => `${element.equipmentInfo?.machineComputerText}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.stinaVersion',
    header: 'Version Stina',
    cell: (element: MachineListDto) => `${element.equipmentInfo?.stinaVersion}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.windowsVersionText',
    header: 'Version Windows',
    cell: (element: MachineListDto) => `${element.equipmentInfo?.windowsVersionText}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.masenVersion',
    header: 'Version Masen',
    cell: (element: MachineListDto) => `${element.equipmentInfo?.masenVersion}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.stanford2010Version',
    header: 'Stanford2010 version',
    cell: (element: MachineListDto) => `${element.equipmentInfo?.stanford2010Version}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.sendPinFilesForPulp',
    header: 'Skicka pinfiler för massa',
    cell: (element: MachineListDto) => `${element.equipmentInfo?.sendPinFilesForPulp ? 'Ja' : 'Nej'}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.fileSendingActive',
    header: 'Filskick aktivt',
    cell: (element: MachineListDto) => `${element.equipmentInfo?.fileSendingActive ? 'Ja' : 'Nej'}`,
    ...baseColumnValues
  }
]

export const productionColumns = [
  {
    columnDef: 'productionInfo.basePerformance',
    header: 'Grundprestation',
    cell: (element: MachineListDto) => `${element.productionInfo.basePerformance}`,
    ...baseColumnValues,
    align: 'right'
  },
  {
    columnDef: 'productionInfo.fuelConsumption',
    header: 'Bränsleförbrukning',
    cell: (element: MachineListDto) => `${element.productionInfo.fuelConsumption}`,
    ...baseColumnValues,
    align: 'right'
  },
  {
    columnDef: 'productionInfo.oilConsumption',
    header: 'Oljeförbrukning',
    cell: (element: MachineListDto) => `${element.productionInfo.oilConsumption}`,
    ...baseColumnValues,
    align: 'right'

  },
  {
    columnDef: 'productionInfo.numberOfWheels',
    header: 'Antal hjul',
    cell: (element: MachineListDto) => `${element.productionInfo.numberOfWheels}`,
    ...baseColumnValues,
    align: 'right'
  },
  {
    columnDef: 'productionInfo.tireDimension',
    header: 'Däckdim',
    cell: (element: MachineListDto) => `${element.productionInfo.tireDimension}`,
    ...baseColumnValues
  },
  {
    columnDef: 'productionInfo.loadingCapacity',
    header: 'Lastkapacitet',
    cell: (element: MachineListDto) => `${element.productionInfo.loadingCapacity}`,
    ...baseColumnValues,
    align: 'right'
  },
  {
    columnDef: 'productionInfo.craneLength',
    header: 'Kranlängd',
    cell: (element: MachineListDto) => `${element.productionInfo.craneLength}`,
    ...baseColumnValues,
    align: 'right'
  },
  {
    columnDef: 'productionInfo.connectedToGrotTeam',
    header: 'Kopplad till Grotlag',
    cell: (element: MachineListDto) => `${element.productionInfo.connectedToGrotTeam}`,
    ...baseColumnValues
  }
]

//ColumnDef måste spegla nesting för att sortering ska fungera
export const baseColumns = [
  {
    columnDef: 'baseInfo.teams.teamId',
    header: 'Lag',
    cell: (element: MachineListDto) => `${element.baseInfo.teams?.filter(t => t.active).map(team => team.teamId).join('<br>')}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.teams.name',
    header: 'Namn',
    cell: (element: MachineListDto) => `${`${element.baseInfo.teams?.filter(t => t.active).map(team => team.name).join('<br>')}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.ownerType',
    header: 'Ägartyp',
    cell: (element: MachineListDto) => `${`${element.baseInfo.ownerType}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.machineTypeText',
    header: 'Maskintyp',
    cell: (element: MachineListDto) => `${`${element.baseInfo.machineTypeText}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.manufacturer',
    header: 'Tillverkare',
    cell: (element: MachineListDto) => `${`${element.baseInfo.manufacturer}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.model',
    header: 'Modell',
    cell: (element: MachineListDto) => `${`${element.baseInfo.model}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.modelYear',
    header: 'Årsmodell',
    cell: (element: MachineListDto) => `${`${element.baseInfo.modelYear}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.machineStatusText',
    header: 'Status',
    cell: (element: MachineListDto) => `${`${element.baseInfo.machineStatusText}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.ownerText',
    header: 'Entreprenör',
    cell: (element: MachineListDto) => `${`${element.baseInfo.ownerText}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.productionTechnicianAreas',
    header: 'Område',
    cell: (element: MachineListDto) => `${`${element.baseInfo.productionTechnicianAreas?.map(area => area).join('<br>')}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.productionLeaders',
    header: 'Produktionsledare',
    cell: (element: MachineListDto) => `${`${element.baseInfo.productionLeaders?.map(leader => leader).join('<br>')}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.registrationNumber',
    header: 'Regnr',
    cell: (element: MachineListDto) => `${`${element.baseInfo.registrationNumber}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.manufacturingNumber',
    header: 'Tillverkningsnr',
    cell: (element: MachineListDto) => `${`${element.baseInfo.manufacturingNumber}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.isSchoolForwarder',
    header: 'Skolskotare',
    cell: (element: MachineListDto) => `${`${element.baseInfo.isSchoolForwarderText}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.isGrotForwarder',
    header: 'Grotskotare',
    cell: (element: MachineListDto) => `${`${element.baseInfo.isGrotForwarderText}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.isDemoMachine',
    header: 'Demomaskin',
    cell: (element: MachineListDto) => `${`${element.baseInfo.isDemoMachineText}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.notes',
    header: 'Anteckningar',
    cell: (element: MachineListDto) => `${`${element.baseInfo.notes}`}`,
    ...baseColumnValues
  }
];

export const defaultColumns = [
  {
    columnDef: 'machineId',
    header: 'Maskinnr',
    cell: (element: MachineListDto) => element.machineId,
    route: (element: MachineListDto) => `/machine/${element.id}`,
    required: true
  }
]

export const allColumns = [
  {
    columnDef: 'machineId',
    header: 'Maskinnr',
    cell: (element: MachineListDto) => element.machineId,
    route: (element: MachineListDto) => `/machine/${element.id}`,
    required: true,
    visible: true,
  },
  {
    columnDef: 'baseInfo.teams.name',
    header: 'Maskinlagsnamn',
    cell: (element: MachineListDto) => `${`${element.baseInfo.teams?.filter(t => t.active).map(team => team.name).join('<br>')}`}`,
    ...baseColumnValues,
    visible: true
  },
  {
    columnDef: 'baseInfo.teams.teamId',
    header: 'Maskinlagskod',
    cell: (element: MachineListDto) => "",
    cellList: (element: MachineListDto) => element.baseInfo.teams?.filter(t => t.active).map(team => ({ text: team.teamId, url: `/team/${team.id}` })),
    visible: true,
    required: false,
  },
  {
    columnDef: 'baseInfo.ownerType',
    header: 'Ägartyp',
    cell: (element: MachineListDto) => `${`${element.baseInfo.ownerType}`}`,
    ...baseColumnValues,
    visible: true
  },
  {
    columnDef: 'baseInfo.machineTypeText',
    header: 'Maskintyp',
    cell: (element: MachineListDto) => `${`${element.baseInfo.machineTypeText}`}`,
    ...baseColumnValues,
    visible: true
  },
  {
    columnDef: 'baseInfo.manufacturer',
    header: 'Tillverkare',
    cell: (element: MachineListDto) => `${`${element.baseInfo.manufacturer}`}`,
    ...baseColumnValues,
    visible: true
  },
  {
    columnDef: 'baseInfo.model',
    header: 'Modell',
    cell: (element: MachineListDto) => `${`${element.baseInfo.model}`}`,
    ...baseColumnValues,
    visible: true
  },
  {
    columnDef: 'baseInfo.modelYear',
    header: 'Årsmodell',
    cell: (element: MachineListDto) => `${`${element.baseInfo.modelYear}`}`,
    ...baseColumnValues,
    visible: true
  },
  {
    columnDef: 'baseInfo.machineStatusText',
    header: 'Status',
    cell: (element: MachineListDto) => `${`${element.baseInfo.machineStatusText}`}`,
    ...baseColumnValues,
    visible: true
  },
  {
    columnDef: 'biometriaInfo.biometriaGpxId',
    header: 'SDCID',
    cell: (element: MachineListDto) => `${element.biometriaInfo.biometriaGpxId}`,
    ...baseColumnValues,
    visible: true
  },
  {
    columnDef: 'biometriaInfo.biometriaCompanyId',
    header: 'Avverkningsföretag-Id',
    cell: (element: MachineListDto) => `${element.biometriaInfo.biometriaCompanyId}`,
    ...baseColumnValues
  },
  {
    columnDef: 'biometriaInfo.biometriaPassword',
    header: 'SDC lösenord',
    cell: (element: MachineListDto) => `${element.biometriaInfo.biometriaPassword}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.ownerText',
    header: 'Entreprenör',
    cell: (element: MachineListDto) => `${`${element.baseInfo.ownerText}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.productionTechnicianAreas',
    header: 'Område',
    cell: (element: MachineListDto) => `${`${element.baseInfo.productionTechnicianAreas?.map(area => area).join('<br>')}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.productionLeaders',
    header: 'Produktionsledare',
    cell: (element: MachineListDto) => `${`${element.baseInfo.productionLeaders?.map(leader => leader).join('<br>')}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.registrationNumber',
    header: 'Regnr',
    cell: (element: MachineListDto) => `${`${element.baseInfo.registrationNumber}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.manufacturingNumber',
    header: 'Tillverkningsnr',
    cell: (element: MachineListDto) => `${`${element.baseInfo.manufacturingNumber}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.isSchoolForwarder',
    header: 'Skolskotare',
    cell: (element: MachineListDto) => `${`${element.baseInfo.isSchoolForwarderText}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.isGrotForwarder',
    header: 'Grotskotare',
    cell: (element: MachineListDto) => `${`${element.baseInfo.isGrotForwarderText}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.isDemoMachine',
    header: 'Demomaskin',
    cell: (element: MachineListDto) => `${`${element.baseInfo.isDemoMachineText}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.notes',
    header: 'Anteckningar',
    cell: (element: MachineListDto) => `${`${element.baseInfo.notes}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'baseInfo.created',
    header: 'Skapad',
    cell: (element: MachineListDto) => `${`${element.baseInfo.created}`}`,
    ...baseColumnValues,
    minWidth: 165,
  },
  {
    columnDef: 'baseInfo.lastModified',
    header: 'Ändrad',
    cell: (element: MachineListDto) => `${`${element.baseInfo.lastModified}`}`,
    ...baseColumnValues,
    minWidth: 165
  },
  {
    columnDef: 'equipmentInfo.hasHighPrecisionCraneTipCoordinate',
    header: 'Kranspetskoordinat, högprecision',
    cell: (element: MachineListDto) => `${`${element.equipmentInfo.hasHighPrecisionCraneTipCoordinateText}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.hasRtk',
    header: 'RTK',
    cell: (element: MachineListDto) => `${`${element.equipmentInfo.hasRtkText}`}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.machineComputerText',
    header: 'Maskindator',
    cell: (element: MachineListDto) => `${element.equipmentInfo?.machineComputerText}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.stinaVersion',
    header: 'Version Stina',
    cell: (element: MachineListDto) => `${element.equipmentInfo?.stinaVersion}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.windowsVersionText',
    header: 'Version Windows',
    cell: (element: MachineListDto) => `${element.equipmentInfo?.windowsVersionText}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.masenVersion',
    header: 'Version Masen',
    cell: (element: MachineListDto) => `${element.equipmentInfo?.masenVersion}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.stanford2010Version',
    header: 'Version Stanford2010',
    cell: (element: MachineListDto) => `${element.equipmentInfo?.stanford2010Version}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.sendPinFilesForPulp',
    header: 'Skicka pinfiler för massa',
    cell: (element: MachineListDto) => `${element.equipmentInfo?.sendPinFilesForPulp ? 'Ja' : 'Nej'}`,
    ...baseColumnValues
  },
  {
    columnDef: 'equipmentInfo.fileSendingActive',
    header: 'Filskick aktivt',
    cell: (element: MachineListDto) => `${element.equipmentInfo?.fileSendingActive ? 'Ja' : 'Nej'}`,
    ...baseColumnValues
  },
  {
    columnDef: 'productionInfo.basePerformance',
    header: 'Grundprestation',
    cell: (element: MachineListDto) => `${element.productionInfo.basePerformance}`,
    ...baseColumnValues,
    align: 'right'
  },
  {
    columnDef: 'productionInfo.fuelConsumption',
    header: 'Bränsleförbrukning',
    cell: (element: MachineListDto) => `${element.productionInfo.fuelConsumption}`,
    ...baseColumnValues,
    align: 'right'
  },
  {
    columnDef: 'productionInfo.oilConsumption',
    header: 'Oljeförbrukning',
    cell: (element: MachineListDto) => `${element.productionInfo.oilConsumption}`,
    ...baseColumnValues,
    align: 'right'
  },
  {
    columnDef: 'productionInfo.numberOfWheels',
    header: 'Antal hjul',
    cell: (element: MachineListDto) => `${element.productionInfo.numberOfWheels}`,
    ...baseColumnValues,
    align: 'right'
  },
  {
    columnDef: 'productionInfo.tireDimension',
    header: 'Däckdim',
    cell: (element: MachineListDto) => `${element.productionInfo.tireDimension}`,
    ...baseColumnValues
  },
  {
    columnDef: 'productionInfo.loadingCapacity',
    header: 'Lastkapacitet',
    cell: (element: MachineListDto) => `${element.productionInfo.loadingCapacity}`,
    ...baseColumnValues,
    align: 'right'
  },
  {
    columnDef: 'productionInfo.craneLength',
    header: 'Kranlängd',
    cell: (element: MachineListDto) => `${element.productionInfo.craneLength}`,
    ...baseColumnValues,
    align: 'right'
  },
  {
    columnDef: 'productionInfo.connectedToGrotTeam',
    header: 'Kopplad till Grotlag',
    cell: (element: MachineListDto) => `${element.productionInfo.connectedToGrotTeam ? 'Ja' : 'Nej'}`,
    ...baseColumnValues
  }
]
